import {CampaignStatsData} from './campaign-stats-data';

export class CampaignStats {
  data: CampaignStatsData[];

  constructor(values: Partial<CampaignStats> = {}) {
    this.data = values.data.map(d => new CampaignStatsData(d));
  }
}
